import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  IconButton,
  Alert,
} from "@mui/material";
import {
  DataGridPremium,
  GridColDef,
  GridRowSelectionModel,
  GridToolbar,
} from "@mui/x-data-grid-premium";
import { SetStateAction, useContext, useEffect, useState } from "react";
import {
  fetchRelatedProducts,
  createXevmpd,
  fetchXevmpdList,
} from "../../api/apiFunctions";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { XevmpdContext } from "../../App";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import NoRecordsFound from "../../components/NoRecordsFound";
import { Description } from "@mui/icons-material";

interface XevmpdPackageProps {
  open: boolean;
  onClose: () => void;
  regdata: any[];
  sideMenuData: any;
  eleigibleRegrecords:any[]
}

const packRows = Array.from({ length: 50 }, (_, index) => ({
  id: index + 1,
  name: `Pack-${index + 1}`,
  type: index % 2 === 0 ? "Box" : "Container",
  size: `${index + 1 * 10}`,
}));

const packColumns: GridColDef[] = [
  { field: "packageName", headerName: "Package Name", flex: 1 },
  { field: "packageType", headerName: "Package Type", flex: 0.5 },
  { field: "packageSize", headerName: "Package Size", flex: 0.3 },
];

export const XevmpdPackage: React.FC<XevmpdPackageProps> = ({
  open,
  onClose,
  regdata,
  sideMenuData,
  eleigibleRegrecords
}) => {
  const [packLevel, setPackLevel] = useState<"yes" | "no">("no");
  const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>(
    []
  );
  const [pageSize, setPageSize] = useState<number>(10);
  const [data, setData] = useState<any[]>([]);
  const [PackageData, setPackageData] = useState<any[]>([]);
  const navigator = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [recordAlreadyexist, setrecordAlreadyexist] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const { allXevmpdRows } = useContext(XevmpdContext);
  const [initiateButtonDisabled, setInitiateButtonDisabled] = useState<boolean>(true);
  const { enqueueSnackbar } = useSnackbar();
  const resetState = () => {
    setPackLevel("no");
    setSelectionModel([]);
    setPageSize(10);
    setData([]);
    setPackageData([]);
    setLoading(false);
    setrecordAlreadyexist(false);
  };
useEffect(() => {
    packLevel === "no"?setInitiateButtonDisabled(false):setInitiateButtonDisabled(true);
  }, [packLevel]);
  useEffect(() => {
    if (!open) {
      resetState();
      setError(false);
    }
  }, [open, onClose]);

  useEffect(() => {
    const getAllMissingPackageIds = (data: any[]) => {
      if (!data?.length) return [];

      const recordId = regdata[0]?.recordID || regdata[0]?.recordId;
      return data
        .filter(item => item.regId === recordId)
        .flatMap(item => item.missingPackageIds);
    };
    const getData = async () => {
      const result = await fetchRelatedProducts(regdata[0]?.productId);
      if (result) {
        const packages = regdata[0]?.sectionTree?.Packages;
        if (packages?.Packages?.length > 0) {
          const RegLinkedPackages = result.data.filter((item: { id: any }) =>
            packages?.Packages?.includes(item.id)
          );
          setData(RegLinkedPackages);
          let missingpackages = getAllMissingPackageIds(eleigibleRegrecords);
          const getStatusByRegId = (data: any[], regId: string) => {
            return data.find(item => item.regId === regId)?.linked_through || "REGID_NOT_FOUND";
          };
          const statusofregrecord = getStatusByRegId(eleigibleRegrecords, regdata[0]?.recordID);
          if (statusofregrecord === "LINKED_THROUGH_REGISTRATION") {
            setrecordAlreadyexist(true);
            setPackageData(RegLinkedPackages);
          } else {
            if (statusofregrecord === "LINKED_THROUGH_PACKAGE") {
              let matchFound = false;
              const missingSet = new Set(missingpackages || []);
              const updatedPackRows = RegLinkedPackages.map((item: { id: any }) => {
                const isMatched = missingSet.has(item.id);
                if (isMatched) {
                  matchFound = true;
                }
                return {
                  ...item,
                  disabled: missingSet.size > 0 ? !isMatched : false,
                };
              });
              matchFound ? setrecordAlreadyexist(true) : setrecordAlreadyexist(false);
              setPackageData(updatedPackRows);
            }
            else {
              setPackageData(RegLinkedPackages);
            }
          }
        } else {
          setData([]);
        }
      }
    };

    getData();
  }, [open]);

  // useEffect(() => {
  //   let packagedata: any[] = [];
  //   const getallxevmpddata = async () => {
  //     //const results = await fetchXevmpdList({ page: 0, pageSize: 100000 }, { showActive: true, showDeleted: true, showSubmitted: true }, []);
  //     let reglevelxevmpdcreated = false;
  //     const xevmpddata = allXevmpdRows;
  //     const filtered = xevmpddata.filter(
  //       (entry: { xevmpdStatus: number; XEVMPDData: string; id: any;Regdata:any }) => {
  //         try {
  //          // const parsed = entry.XEVMPDData;
  //           const reg = entry.Regdata;
  //           const regid = regdata[0]?.recordID?.replace("REG-", "");
  //           if (
  //             reg?.id === regid &&
  //             (entry.xevmpdStatus === 0 || entry.xevmpdStatus === 2)
  //           ) {
  //             return true;
  //           }
  //         } catch (error) {
  //           console.error("Invalid JSON in xevmpdData:", entry.id);
  //           return false;
  //         }
  //       }
  //     );
  //     if (filtered.length === 0) {
  //       setPackageData(data);
  //       setrecordAlreadyexist(false);
  //     } else {
  //       let alreadyexist = false;
  //       for (const xevmpdrecord of filtered) {
  //         const xevmpdataobject = JSON.parse(xevmpdrecord.xevmpdData);
  //         const packagedatasaved = xevmpdataobject.PackageData;
  //         if (xevmpdataobject?.packLevel === false) {
  //           reglevelxevmpdcreated = true;
  //         }
  //         if (xevmpdataobject?.packLevel !== true) {
  //           alreadyexist = true;
  //         }
  //         if (packagedatasaved?.length === 0) {
  //           break;
  //         }
  //         for (const packdata of data) {
  //           if (packdata.id === packagedatasaved.id) {
  //             packdata.disabled = true;
  //             packagedata.push(packdata);
  //             alreadyexist = true;
  //           } else {
  //             packagedata.push(packdata);
  //           }
  //         }
  //       }
  //       const uniquePackages = Array.from(
  //         new Map(packagedata.map((item) => [item.id, item])).values()
  //       );
  //       alreadyexist
  //         ? setrecordAlreadyexist(true)
  //         : setrecordAlreadyexist(false);
  //       if (reglevelxevmpdcreated) {
  //         setrecordAlreadyexist(true);
  //       }

  //       setPackageData(uniquePackages);
  //     }
  //   };
  //   const getAllMissingPackageIds = (data: any[]) => {
  //     if (!data?.length) return [];

  //     const recordId = regdata[0]?.recordID || regdata[0]?.recordId;
  //     return data
  //       .filter(item => item.regId === recordId)
  //       .flatMap(item => item.missingPackageIds);
  //   };
  //   let missingpackages = getAllMissingPackageIds(eleigibleRegrecords);
  //   //getallxevmpddata();
  // }, [data]);

  const generateRegionRecords = (basePayload: any) => {
    const regionSet = [
      { country: basePayload.xevmpdData.Regdata.country },
      { country: "Norway" },
      { country: "Iceland" },
      { country: "Liechtenstein" },
    ];

    return regionSet.map(r => {
      const cloned = JSON.parse(JSON.stringify(basePayload));

      // Set correct country for the record
      cloned.xevmpdData.Regdata.country = r.country;

      cloned.xevmpdData.MenuData.Authorisation.authorizationCountryCode = r.country;

      return cloned;
    });
  };


  const savexEVMPDData = async () => {
    setLoading(true);
    const selectedRows = data.filter((row) =>
      selectionModel.includes((row as any).id)
    );
    if (selectedRows.length === 0 && packLevel === "yes") {
      setError(true);
      setLoading(false);
      return;
    } else {
      setError(false);
    }
    console.log("Package Selected", selectedRows);
    console.log("Registration record selected:", regdata);
    const Regid = regdata[0].recordID.replace("REG-", "");
    const RegidforaddionAPI = regdata[0].id;
    const Registrationobject = regdata[0];
    const procType = Registrationobject.procedureType?.trim();
    const isCP = ["Centralised Procedure", "Centralized Procedure"].includes(procType);

    let xevmpdrecordcreated = false;
    if (selectedRows.length > 0 && packLevel === "yes") {
      for (const packagedata of selectedRows) {
        const XevMPDData = [
          {
            registrationId: RegidforaddionAPI,
            xevmpdData: {
              Regdata: {
                ...Registrationobject,
                authorizationNumber:
                  sideMenuData.Authorisation.authorizationNumber,
                packLevel: true,
              },
              PackageData: { ...packagedata, disabled: true },
              packLevel: true,
              MenuData: {
                ...sideMenuData,
                "Presentation Details": sideMenuData["Presentation Details"]?.map((item:any) => ({
                ...item,
                description: item.description?.trim()
                  ? item.description
                  : packagedata?.description
              })),
                Authorisation: {
                  ...sideMenuData.Authorisation,
                  "mRP/DCP/EMEAnumber":
                    sideMenuData.Authorisation.procedureNumber ?? "",
                  authorizationCountryCode: Registrationobject.country,
                },
              },
              xevmpdFormData: { version: 0.1, xevmpdStatus: "Draft" },
            },
            createdBy: Cookies.get("USER_EMAIL"),
          },
        ];
        console.log("Updated Code");
        let payloadToSend = XevMPDData;
        // Create 4 CP/EEA records only for Centralised Procedure
        if (isCP) {
          payloadToSend = generateRegionRecords(XevMPDData[0]);
        }
        const response = await createXevmpd(payloadToSend);
        if (response?.data.status === 200) {
          xevmpdrecordcreated = true;
        }
      }
    } else {
      const basePayload = {
          registrationId: RegidforaddionAPI,
          xevmpdData: {
            Regdata: {
              ...Registrationobject,
              authorizationNumber:
                sideMenuData.Authorisation.authorizationNumber,
              packLevel: false,
            },
            PackageData: {},
            packLevel: false,
            MenuData: {
              ...sideMenuData,
              Authorisation: {
                ...sideMenuData.Authorisation,
                "mRP/DCP/EMEAnumber":
                  sideMenuData.Authorisation.procedureNumber ?? "",
                authorizationCountryCode: Registrationobject.country,
              },
            },
            xevmpdFormData: { version: 0.1, xevmpdStatus: "Draft" },
          },
          createdBy: Cookies.get("USER_EMAIL"),
      };
      let payloadToSend = [basePayload];
      if (isCP) {
        payloadToSend = generateRegionRecords(basePayload);
      }
      console.log("Payload sent to backend:", payloadToSend);
      const response = await createXevmpd(payloadToSend);
      if (response?.data.status === 200) {
        xevmpdrecordcreated = true;
      }
    }
    if (xevmpdrecordcreated) {
      enqueueSnackbar("xEVMPD(s) created successfully", {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    }
    setLoading(false);
    navigator("/idmp-list", { replace: true });
  };

  useEffect(() => {
    if (recordAlreadyexist) {
      setPackLevel("yes");
    } else {
      setPackLevel("no");
    }
  }, [recordAlreadyexist]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          width: "800px",
          maxWidth: "90%",
          borderRadius: "0px",
          "& .MuiDialogContent-root p": {
            fontSize: "12px !important",
            color: "#0d0d0d",
          },
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(15, 15, 15, 0.4) !important",
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" fontSize={20} fontWeight={500}>
          Initiate xEVMPD ({regdata[0]?.recordID})
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" fontSize={12} sx={{ mb: 1 }}>
          Do you want to submit xEVMPD at the pack level?
        </Typography>

        <RadioGroup
          row
          value={packLevel}
         // onChange={(e) => setPackLevel(e.target.value as "yes" | "no")}
          onChange={(e) => {
            setPackLevel(e.target.value as "yes" | "no");
            e.target.value === "no"?setInitiateButtonDisabled(false):setInitiateButtonDisabled(true);
            if(e.target.value === "no"){
              setSelectionModel([]);
            }
          }}
        >
          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
          {recordAlreadyexist ? (
            <Tooltip title="Registration-level xEVMPD cannot be initiated as one or more packages are already part of a pack-level xEVMPD record">
              <span>
                <FormControlLabel
                  value="no"
                  control={<Radio />}
                  label="No"
                  disabled
                />
              </span>
            </Tooltip>
          ) : (
            <FormControlLabel value="no" control={<Radio />} label="No" />
          )}
        </RadioGroup>

        {packLevel === "yes" && (
          <>
            <Typography variant="body1" sx={{ mt: 2, mb: 1, fontSize: "12px" }}>
              Select the packs to Initiate xEVMPD{" "}
              <span style={{ color: "red" }}>*</span>
            </Typography>

            <Box sx={{ width: "100%" }}>
              {/* DataGrid Box */}
              <Box sx={{ height: 300 }}>
                <DataGridPremium
  rows={PackageData}
  columns={packColumns}
  checkboxSelection
  rowSelectionModel={selectionModel}
  onRowSelectionModelChange={(newSelection) => {
  setSelectionModel(newSelection);
  newSelection.length > 0? setInitiateButtonDisabled(false): setInitiateButtonDisabled(true);
}}
  slots={{
    noRowsOverlay: NoRecordsFound,
    noResultsOverlay: NoRecordsFound,
  }}
  pagination
  pageSizeOptions={[5, 10, 20]}
  onPaginationModelChange={(model) => {
    setPageSize(model.pageSize);
  }}
  initialState={{
    pagination: {
      paginationModel: { pageSize: 5 },
    },
    pinnedColumns: { right: [] },
  }}
  isRowSelectable={(params) => !params.row.disabled}
  sx={{
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
    "& .MuiDataGrid-columnHeaders": {
      fontSize: 13,
      fontWeight: 500,
      backgroundColor: "#f8fafdff",
    },
    "& .MuiDataGrid-cell": {
      fontSize: 13,
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: "none",
    },
    // Fix for overlay positioning and centering
    "& .MuiDataGrid-overlay": {
      height: "100% !important",
      width: "100% !important",
      display: "flex !important",
      alignItems: "center !important",
      justifyContent: "center !important",
      position: "absolute !important",
      top: "0 !important",
      left: "0 !important",
      right: "0 !important",
      bottom: "0 !important",
      backgroundColor: "white !important",
    },
    "& .MuiDataGrid-overlayWrapper": {
      height: "100% !important",
      position: "relative !important",
    },
    // Style the image inside
    "& .MuiDataGrid-overlay img": {
      width: "80px !important",
      height: "80px !important",
    },
    
  }}
/>
              </Box>

              {/* Error Alert BELOW grid */}
              {error && (
                <Typography
                  variant="body2"
                  sx={{ color: "red !important", mt: 1 }}
                >
                  Please select at least one pack to initiate XEVMPD
                </Typography>
              )}
            </Box>
          </>
        )}

        <Box
          display="flex"
          alignItems="center"
          bgcolor="#e8efff"
          borderRadius={1}
          p={1.5}
        >
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: "50%",
              bgcolor: "#2563eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: 12,
              fontWeight: "bold",
              mr: 1.5,
            }}
          >
            i
          </Box>
          <Typography sx={{ fontSize: 13 }}>
            Make sure all required xEVMPD fields have been filled before
            initiating.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: "#f4f1f1ff !important", // light grey
            color: "black !important",
            borderRadius: "6px",
            textTransform: "none", // preserve 'Cancel' casing
            boxShadow: "none",
            fontWeight: 400,
            fontSize: "0.875rem",
            minWidth: "64px",
            padding: "6px 16px",
            "&:hover": {
              backgroundColor: "#e0e0e0 !important",
              boxShadow: "none",
            },
          }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button variant="contained" onClick={savexEVMPDData} disabled = {initiateButtonDisabled}>
          Initiate xEVMPD
        </Button>
      </DialogActions>
      <Loading open={loading} />
    </Dialog>
  );
};
